import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-foreground-200 mt-20">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-accent-950">
                <i className="ri-coin-line text-xl" />
              </span>
              <span className="text-lg font-heading font-bold text-primary-400">黄金</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-300">
              专注黄金价格行情、市场分析与投资资讯，为关注贵金属投资的个人投资者与财经研究人员，
              提供权威、及时、专业的行情数据与投资指导内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">
              <Link to="/">网站导航</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-300 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/gold-price" className="text-foreground-300 hover:text-primary-400 transition-colors">黄金行情</Link></li>
              <li><Link to="/category/investment-news" className="text-foreground-300 hover:text-primary-400 transition-colors">投资资讯</Link></li>
              <li><Link to="/about" className="text-foreground-300 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">
              <Link to="/category/investment-news">热门专题</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/investment-news" className="text-foreground-300 hover:text-primary-400 transition-colors">黄金投资入门</Link></li>
              <li><Link to="/category/investment-news" className="text-foreground-300 hover:text-primary-400 transition-colors">市场回顾</Link></li>
              <li><Link to="/category/investment-news" className="text-foreground-300 hover:text-primary-400 transition-colors">政策与央行</Link></li>
              <li><Link to="/category/investment-news" className="text-foreground-300 hover:text-primary-400 transition-colors">热点解读</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">
              <Link to="/about">联系我们</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2 text-foreground-300">
                <i className="ri-mail-line text-primary-400" />
                contact@gold-portal.example
              </li>
              <li className="flex items-center gap-2 text-foreground-300">
                <i className="ri-time-line text-primary-400" />
                数据更新：交易日 09:00 - 24:00
              </li>
              <li className="flex items-center gap-2 text-foreground-300">
                <i className="ri-map-pin-line text-primary-400" />
                上海市浦东新区金融信息服务区
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10">
          <p className="text-xs leading-relaxed text-foreground-400 mb-4">
            免责声明：本站所有行情数据、图表及文章内容均为演示数据，仅用于信息展示与学习参考，不构成任何投资建议。
            黄金及贵金属投资存在市场风险，价格可能波动并导致本金损失，投资者应独立判断并自行承担投资风险。
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-foreground-400">
            <span>© 2026 黄金 Gold Portal 保留所有权利</span>
            <span>本站行情数据均为演示数据，更新时间以页面标注为准</span>
          </div>
        </div>
      </div>
    </footer>
  );
}